import { POST, GET } from '@/utils/axios.js'

// 发送验证码
export const GetVcode = (data) => POST('/sms/sendVCode', data)

// 登录
export const Login = (data) => POST('/user/login', data)

// 登出
export const Logout = (data) => POST('/user/logout', data)

// 字典
export const GetDict = () => GET('/common/all')

// 获取用户信息
export const GetUserInfo = () => POST('/user/getUserInfo', {}, {}, null, false)

// 保存用户信息
export const SaveUserInfo = (data) => POST('/user/saveUserInfo', data)

export const wxLogin = (data) => POST('/user/wxLogin', data)

// 账号密码登录
export const LoginByPassword = (data) => POST('/user/login', data)

// 获取验证码图片
export const GetCaptcha = () => GET('/common/captchaImage')

export const apiGetNoticeList = () => POST('/common/getNotificationList', {})

export const apiGetPlatformConfigByGroup= (data) => POST('/common/getPlatformConfigByGroup', data)

export const apiGetPlatformConfigByKey= (data) => POST('/common/getPlatformConfigByKey', data)

export const apiGetPlatformConfigList = () => POST('/common/getPlatformConfigList', {})

export const apiGetArticlesByCode= (data) => POST('/common/getArticlesByCode', data)

export const apiGetNavInfoList = () => POST('/common/getNavList', {})